import CurrentTime from '@/models/current-time/CurrentTime'
import { SkuPrice } from '@/models/item/sku'

import { Sku } from './model/item'

export type ActionButtonViewModel = NoneViewModel
  | StandardOrderViewModel
  | PreOrderViewModel
  | RestockRequestViewModel
  | NewArrivalRequestViewModel
  | ComingSoonViewModel
  | SoldOutViewModel

export interface RequestContext {
  isLineAccountAssociated: boolean | null
  lineAssociationLoadError: boolean
}

interface NoneViewModel {
  type: 'none'
}

interface StandardOrderViewModel {
  type: 'standard-order'
  fkuId: string
  skuId: string
  price: SkuPrice
  quantity: number
}

interface PreOrderViewModel {
  type: 'pre-order'
  fkuId: string
  skuId: string
  price: SkuPrice
  quantity: number
  deliveryStartAt: string
}

interface RestockRequestViewModel {
  type: 'restock-request'
  skuId: string
  requestContext: RequestContext
}

interface NewArrivalRequestViewModel {
  type: 'new-arrival-request'
  skuId: string
  requestContext: RequestContext
}

interface ComingSoonViewModel {
  type: 'coming-soon'
}

interface SoldOutViewModel {
  type: 'sold-out'
}

export function createActionButtonViewModel(
  selectedFkuId: string | null,
  selectedSku: Sku | null,
  selectedQuantity: number,
  current: CurrentTime,
  requestContext: RequestContext
): ActionButtonViewModel {
  if (!selectedFkuId || !selectedSku) {
    return {
      type: 'none',
    }
  }

  switch (selectedSku.resolveSalesStatus(current.now)) {
    case 'standard-order':
      return {
        type: 'standard-order',
        fkuId: selectedFkuId,
        skuId: selectedSku.id,
        price: selectedSku.price,
        quantity: selectedQuantity,
      }
    case 'pre-order':
      return {
        type: 'pre-order',
        fkuId: selectedFkuId,
        skuId: selectedSku.id,
        price: selectedSku.price,
        quantity: selectedQuantity,
        deliveryStartAt: selectedSku.deliveryStartAt,
      }
    case 'restock-request':
      return {
        type: 'restock-request',
        skuId: selectedSku.id,
        requestContext,
      }
    case 'new-arrival-request':
      return {
        type: 'new-arrival-request',
        skuId: selectedSku.id,
        requestContext,
      }
    case 'coming-soon':
      return { type: 'coming-soon' }
    case 'sold-out':
      return { type: 'sold-out' }
    case 'none':
    default:
      return { type: 'none' }
  }
}
